import { CalendarDays } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { Countdown } from "@/components/Countdown";
import { DRAW_SCHEDULE } from "@/config/campaign";

export const NextDraw = () => (
  <section id="ziehung" className="scroll-mt-20 bg-ink py-16 md:py-24" data-testid="next-draw-section">
    <div className="mx-auto max-w-[760px] px-5 text-center">
      <Reveal>
        <p className="text-xs font-bold uppercase tracking-[0.25em] text-gold">Ziehungen</p>
        <h2 className="mt-3 font-display text-4xl font-extrabold tracking-tight text-offwhite md:text-5xl">
          Nächste Ziehung.
        </h2>
      </Reveal>
      <Reveal delay={0.1}>
        <div className="mt-8 flex justify-center">
          <Countdown centered tone="dark" />
        </div>
      </Reveal>
      <Reveal delay={0.2}>
        <div className="mt-10 rounded-[18px] border border-white/10 bg-coal p-6 text-left" data-testid="draw-schedule-list">
          <p className="flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] text-gold">
            <CalendarDays className="h-4 w-4" strokeWidth={2} /> Alle Ziehungstermine
          </p>
          <ul className="mt-4 space-y-2.5">
            {DRAW_SCHEDULE.map((d) => (
              <li key={d.date} className="flex items-baseline justify-between gap-4 text-sm">
                <span className="font-semibold text-offwhite">{d.label}</span>
                <span className="text-right text-offwhite/60">
                  {d.prizes.map((p) => `${p.count}× ${p.type === "main7years" ? "Hauptpreis" : p.type === "cash100" ? "CHF 100" : "Steuererklärung 2027"}`).join(" · ")}
                </span>
              </li>
            ))}
          </ul>
          <p className="mt-4 border-t border-white/10 pt-4 text-xs text-offwhite/50" data-testid="winners-note">
            Nächste Gewinner werden am {DRAW_SCHEDULE[0].label} gezogen. Wer gewinnt, wird telefonisch und per E-Mail kontaktiert.
          </p>
        </div>
      </Reveal>
    </div>
  </section>
);
